import { Component, OnInit } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { ToasterService } from 'angular2-toaster';
import * as _ from 'lodash';

const DEBOUNCE_TIME = 500;
const ES_RESULTS_SIZE = 20;
const ES_LARGER_SEARCH_AMOUNT = 100;

const PAGE_SIZE = 100;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'es-dashboard',
    templateUrl: 'esDashboard.component.html',
    styleUrls: ['ESDashboard.component.scss']
})
export class ESDashboardComponent implements OnInit {

    private navIndex = 0;

    handleNavSelect(index) {
        this.navIndex = index;
    }

    constructor(
        private toasterService: ToasterService,
        ) {
    }

    ngOnInit() {

    }

}



// WEBPACK FOOTER //
// ./src/app/elastic-search-dashboard/esDashboard.component.ts